export default "__VITE_PUBLIC_ASSET__6386457c__"